import React from "react";
import { styled } from "@mui/material/styles";
import {
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  Button,
  TextField,
  Typography,
  DialogActions,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

const SubmitBtn = styled(Button)(({ theme }) => ({
  padding: "12px 14px",
  background: "#f05d32",
  borderRadius: "12px",
  border: "1px solid #f05d32",
  color: "#ffffff",
  "&:hover": {
    background: "#f05d32",
  },
}));

const MyTextField = styled(TextField)(({ theme }) => ({
  "& label.Mui-focused": {
    color: "#7d7d7d",
    borderRadius: "12px",
  },
  "& .MuiInput-underline:after": {
    borderBottomColor: "#7d7d7d",
    borderRadius: "12px",
  },
  "& .MuiOutlinedInput-root": {
    "& fieldset": {
      borderColor: "#7d7d7d",
      borderRadius: "12px",
    },
    "&:hover fieldset": {
      borderColor: "#7d7d7d",
      borderRadius: "12px",
    },
    "&.Mui-focused fieldset": {
      borderColor: "#7d7d7d",
      borderRadius: "12px",
    },
  },
}));

const MyDialogTitle = (props) => {
  const { children, onClose, ...other } = props;
  return (
    <DialogTitle
      sx={{
        m: 0,
        p: 2,
        backgroundColor: "#f05d32",
        color: "#fff",
        display: "flex",
        alignItems: "center",
        position: "relative",
      }}
      {...other}
    >
      {children}
      {onClose ? (
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 0,
            top: "50%",
            transform: "translate(0,-50%)",
            color: "#fff",
          }}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </DialogTitle>
  );
};

export default function Address(props) {
  const { component } = props;
  const { open = false } = component.props;
  return (
    <Dialog
      onClose={() => {
        component.props.setOpen(false);
        component.resetCoupon();
      }}
      open={open}
      sx={{
        "& .MuiPaper-rounded": {
          borderRadius: { md: "25px" },
        },
      }}
      maxWidth="xs"
    >
      <MyDialogTitle
        onClose={() => {
          component.props.setOpen(false);
          component.resetCoupon();
        }}
      >
        {component.ucfirst("coupon-dialog-title")}
      </MyDialogTitle>
      <DialogContent sx={{ pt: "16px !important", px: 2, pb: 1 }}>
        <Typography variant="body2">
          {component.trans("coupon-dialog-subtitle")}
        </Typography>
        <form onSubmit={(e) => component.addCoupon(e)}>
          <MyTextField
            variant="outlined"
            margin="normal"
            fullWidth
            name="couponCode"
            label={component.trans("promo-code")}
            type="text"
            id="couponCode"
            placeholder={component.trans("promo-holder")}
            helperText={component.getData("error.couponCode")}
            value={component.getData("default.couponCode", "")}
            onChange={(e) => {
              component.setData({
                "default.couponCode": e.target.value,
              });
            }}
            error={component.dataExists("error.couponCode")}
          />
          <button type="submit" hidden></button>
        </form>
      </DialogContent>
      <DialogActions sx={{ px: 2 }}>
        <SubmitBtn type="submit" fullWidth variant="contained">
          {component.trans("submit-btn")}
        </SubmitBtn>
      </DialogActions>
    </Dialog>
  );
}
